import * as L from 'leaflet'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
import { CommUtils } from '@map-sdk/sdk/utils/CommUtils'
import { AreaViewBase } from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
import type { AreaViewBaseOptions } from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'

interface ElaneStraitDataItem {
  points: [number, number][]
  cname: string
  ename: string
}

/**
 * 全球海峡
 */
class ElaneStraitSymbol extends AreaViewBase {
  layerHash: any = {}
  layerHashName: any = {}
  _tempAreaArray: any = []
  _zoomend = false
  lyGroup!: L.LayerGroup | null
  constructor(map: MyMap, options?: Partial<AreaViewBaseOptions> | undefined) {
    super(map, options)
    this._data = [
      {
        cname: '曼德海峡',
        ename: 'BAB EL MANDEB STRAIT',
        points: [
          [43.05, 12.45],
          [43.67, 12.94],
        ],
      },
      {
        cname: '托雷斯海峡',
        ename: 'TORRES STRAIT',
        points: [
          [142.5, -10.8],
          [143, -9],
        ],
      },
      {
        cname: '白令海峡',
        ename: 'BERING STRAIT',
        points: [
          [-170, 66],
          [-167, 66],
        ],
      },
      {
        cname: '霍尔木兹海峡',
        ename: 'HORMUZ STRAIT',
        points: [
          [56.3, 26.1],
          [56.6, 27.3],
        ],
      },
      {
        cname: '喀拉海峡',
        ename: 'KARA STRAIT',
        points: [
          [56, 70.8],
          [59, 70.2],
        ],
      },
      {
        cname: '朝鲜海峡',
        ename: 'KOREA STRAIT',
        points: [
          [127.2, 34.6],
          [129.5, 33.3],
        ],
      },
      {
        cname: '望加锡海峡',
        ename: 'MAKASSAR STRAIT',
        points: [
          [116.9, -1],
          [119.7, -1],
        ],
      },
      {
        cname: '马六甲海峡',
        ename: 'MALACCA STRAIT',
        points: [
          [101, 1],
          [101, 4],
        ],
      },
      {
        cname: '保克海峡',
        ename: 'PALK STRAIT',
        points: [
          [78, 9.5],
          [80.2, 9.5],
        ],
      },
      {
        cname: '琼州海峡',
        ename: 'QIONGZHOU STRAIT',
        points: [
          [110.2, 20],
          [110.2, 20.3],
        ],
      },
      {
        cname: '新加坡海峡',
        ename: 'STRAIT OF SINGAPORE',
        points: [
          [104, 1.1],
          [104, 1.35],
        ],
      },
      {
        cname: '台湾海峡',
        ename: 'TAIWAN STRAIT',
        points: [
          [118.5, 25.6],
          [121.2, 24.75],
        ],
      },
      {
        cname: '津轻海峡',
        ename: 'TSUGARU STRAIT',
        points: [
          [140.4, 41.2],
          [140.4, 41.6],
        ],
      },
      {
        cname: '巽他海峡',
        ename: 'SUNDA STRAIT',
        points: [
          [105.6, -6.7],
          [105.1, -5.6],
        ],
      },
      {
        cname: '龙目海峡',
        ename: 'LOMBOK STRAIT',
        points: [
          [115.4, -8.4],
          [116.2, -8.4],
        ],
      },
      {
        cname: '宫古海峡',
        ename: 'MIYAKO STRAIT',
        points: [
          [125.4, 24.8],
          [127.6, 26.1],
        ],
      },
      {
        cname: '根室海峡',
        ename: 'NEMURO STRAIT',
        points: [
          [145.21, 44.1],
          [145.77, 44.1],
        ],
      },
      {
        cname: '宗谷海峡',
        ename: 'SOYA KAIKYO',
        points: [
          [142, 45.5],
          [142, 45.9],
        ],
      },
      {
        cname: '对马海峡',
        ename: 'TSUSHIMA STRAIT',
        points: [
          [129.7, 33.8],
          [129.25, 34.15],
        ],
      },

      {
        cname: '达达尼尔海峡',
        ename: 'DARDANELLES STRAIT',
        points: [
          [26.4, 40.3],
          [26.61, 40.15],
        ],
      },
      {
        cname: '戴维斯海峡',
        ename: 'DAVIS STRAIT',
        points: [
          [-63.13, 66.9],
          [-51, 68],
        ],
      },
      {
        cname: '丹麦海峡',
        ename: 'DENMARK STRAIT',
        points: [
          [-37, 69],
          [-22.8, 66.4],
        ],
      },
      {
        cname: '加来海峡',
        ename: 'DOVER STRAIT',
        points: [
          [1.15, 52.27],
          [3.6, 51.18],
        ],
      },
      {
        cname: '刻赤海峡',
        ename: 'KERCH STRAIT',
        points: [
          [36.3, 45.2],
          [36.8, 45.2],
        ],
      },
      {
        cname: '斯卡格拉克海峡',
        ename: 'SKAGERRAK STRAIT',
        points: [
          [9, 57.06],
          [9, 58.4],
        ],
      },
      {
        cname: '大贝尔特海峡',
        ename: 'GREATER BEIT STRAIT',
        points: [
          [10.7, 55.48],
          [11.16, 55.52],
        ],
      },
      {
        cname: '卡特加特海峡',
        ename: 'KATTEGAT STRAIT',
        points: [
          [10.5, 57.1],
          [11.9, 57.2],
        ],
      },
      {
        cname: '厄勒海峡',
        ename: 'ORESUND STRAIT',
        points: [
          [12.69, 55.6],
          [12.86, 55.56],
        ],
      },
      {
        cname: '英吉利海峡',
        ename: 'ENGLISH CHANNEL',
        points: [
          [-2.12, 49.76],
          [-2.12, 50.59],
        ],
      },
      {
        cname: '布里斯托尔海峡',
        ename: 'BRISTOL CHANNEL',
        points: [
          [-4.2, 51.15],
          [-4.2, 51.6],
        ],
      },
      {
        cname: '科林斯运河',
        ename: 'CORINTH CANAL',
        points: [
          [23, 37.9],
          [23, 37.95],
        ],
      },
      {
        cname: '麦哲伦海峡',
        ename: 'MAGELLAN STRAIT',
        points: [
          [-71, -53.05],
          [-70.4, -53.05],
        ],
      },
      {
        cname: '布兰斯菲尔德海峡',
        ename: 'BRANSFIELD STRAIT',
        points: [
          [-60.2, -64],
          [-60.2, -62.5],
        ],
      },
      {
        cname: '德雷克海峡',
        ename: 'DRAKE PASSAGE',
        points: [
          [-62, -63],
          [-67.3, -55.9],
        ],
      },
      {
        cname: '莫桑比克海峡',
        ename: 'MOZAMBIQUE CHANNEL',
        points: [
          [38.8, -15.4],
          [45, -17.7],
        ],
      },
      {
        cname: '好望角',
        ename: 'CAPE OF GOOD HOPE',
        points: [
          [18.44, -36],
          [18.44, -34.3],
        ],
      },
      {
        cname: '巴斯海峡',
        ename: 'BASS STRAIT',
        points: [
          [146.33, -41.2],
          [146.33, -38.5],
        ],
      },
      {
        cname: '库克海峡',
        ename: 'COOK STRAIT',
        points: [
          [174, -41.5],
          [174.9, -41.5],
        ],
      },
      {
        cname: '迪克森海峡',
        ename: 'DIXON ENTRANCE',
        points: [
          [-132.05, 54],
          [-132.05, 54.75],
        ],
      },
      {
        cname: '佛罗里达海峡',
        ename: 'FLORIDA STRAIT',
        points: [
          [-80.8, 23],
          [-80.8, 25.4],
        ],
      },
      {
        cname: '哈得逊海峡',
        ename: 'HUDSON STRAIT',
        points: [
          [-73.7, 62],
          [-73.7, 65],
        ],
      },
      {
        cname: '马基纳克海峡',
        ename: 'MACKINAC STRAIT',
        points: [
          [-84.75, 45.75],
          [-84.75, 45.86],
        ],
      },
      {
        cname: '贝尔岛海峡',
        ename: 'STRAIT OF BELLE ISLE',
        points: [
          [-56.3, 51.3],
          [-56.3, 52],
        ],
      },
      {
        cname: '乔治亚海峡',
        ename: 'STRAIT OF GEORGIA',
        points: [
          [-124.4, 49.35],
          [-123.9, 49.5],
        ],
      },
      {
        cname: '胡安德富卡海峡',
        ename: 'STRAIT OF JUAN DE FUCA',
        points: [
          [-124, 48.1],
          [-124, 48.5],
        ],
      },
      {
        cname: '向风海峡',
        ename: 'WINDWARD PASSAGE',
        points: [
          [-74.2, 20.1],
          [-73.45, 19.75],
        ],
      },
      {
        cname: '尤卡坦海峡',
        ename: 'YUCATAN CHANNEL',
        points: [
          [-86.7, 21.4],
          [-85, 21.9],
        ],
      },
      {
        cname: '圣劳伦斯河',
        ename: 'ST. LAWRENCE RIVER CHANNEL',
        points: [
          [-66.6, 48.7],
          [-67.6, 50],
        ],
      },
      {
        cname: '赫卡特海峡',
        ename: 'HECATE STRAIT',
        points: [
          [-132, 53],
          [-130, 53.7],
        ],
      },
      { cname: '大隅海峡', ename: '', points: [[130.737, 30.865]] },
      { cname: '巴士海峡', ename: '', points: [[121.465, 21.187]] },
      { cname: '民都洛海峡', ename: '', points: [[120.443, 12.533]] },
      { cname: '巴拉巴克海峡', ename: '', points: [[117.241, 7.727]] },
      { cname: '巴拿马运河', ename: '', points: [[-79.572, 8.96]] },
      { cname: '卡里马塔海峡', ename: '', points: [[109.204, -2.482]] },
      { cname: '维蒂亚兹海峡', ename: '', points: [[147.722, -5.9]] },
      { cname: '马鲁古海峡', ename: '', points: [[126.2, 1.143]] },
      { cname: '德朗海峡', ename: '', points: [[178.945, 70.11]] },
      { cname: '维利基茨基海峡', ename: '', points: [[104.326, 77.888]] },
      { cname: '莱斯岛海峡', ename: '', points: [[11.151, 57.404]] },
      { cname: '巴林塘海峡', ename: '', points: [[121.995, 19.756]] },
      { cname: '吕宋海峡', ename: '', points: [[121.959, 20.172]] },
      { cname: '苏伊士运河', ename: '', points: [[32.552, 29.934]] },
      {
        cname: '直布罗陀海峡',
        ename: 'GIBRALTAR STRAIT',
        points: [[-5.601, 35.961]],
      },
      { cname: '梅奈海峡', ename: 'MENAI STRAIT', points: [[-4.257, 53.169]] },
      { cname: '基尔运河', ename: 'KIEL CANAL', points: [[9.693, 54.297]] },
      {
        cname: '墨西拿海峡',
        ename: 'MESSINA STRAIT',
        points: [[15.591, 38.145]],
      },
      { cname: '鞑靼海峡', ename: 'TATAR STRAIT', points: [[141.553, 52.098]] },
      {
        cname: '博斯普鲁斯海峡',
        ename: 'BOSPHORUS STRAIT',
        points: [[29.061, 41.085]],
      },
    ]
    this._polyNameChange()
    this._map.setView({ lat: 6.533345003111799, lng: 87.89062500000001 }, 3)
  }

  _show(): this {
    if (!this._data) {
      console.error('全球海峡展示，请求无数据！')
      return this
    }
    this._data.forEach((item: ElaneStraitDataItem) => this.draw(item))
    return this
  }

  _polyNameChange() {
    this._map.on('zoomend', () => {
      this._zoomend = true
    })

    this._map.on('moveend', () => {
      this._tempAreaArray = []
      for (const item in this.layerHash) {
        const ly = this.layerHashName[item]
        if (ly) {
          this._map.removeLayer(ly)
          delete this.layerHashName[item]
        }
      }

      for (const item in this.layerHash) {
        const layer = this._showName(this.layerHash[item], item)

        const isIntersects = (layer: { getBounds: () => any }) => {
          let res = false
          const layers = Object.values(this.layerHashName) as any
          for (const layer_ of layers) {
            if (layer_.getBounds().intersects(layer.getBounds())) {
              res = true
              break
            }
          }
          return res
        }
        if (layer && !isIntersects(layer)) {
          this.layerHashName[item] = layer
          //缩放延迟执行添加
          if (!this._zoomend)
            this.layerHashName[item] &&
              this._map.addLayer(this.layerHashName[item])
          else {
            this._tempAreaArray.push(this.layerHashName[item])
          }
        }
      }

      //延迟绘制
      setTimeout(() => {
        this._tempAreaArray.forEach((item: L.Layer) => {
          item && this._map.addLayer(item)
        })
      }, 0)
      this._zoomend = false
    })
  }

  draw(o: ElaneStraitDataItem) {
    if (!this.lyGroup) {
      this.lyGroup = L.layerGroup().addTo(this._map)
    }
    const { points, cname } = o

    //绘制线段 多段绘制
    points.forEach((p, i) => {
      const next = points[i + 1]
      let p1, next1, center
      if (points.length == 1) {
        p1 = L.latLng(p[1], p[0])
        p1 = CanvasShipUtils.GPSEncryptByMapToLatLng(p1, this._map)
        center = [p1.lat, p1.lng]
      } else if (next) {
        p1 = L.latLng(p[1], p[0])
        next1 = L.latLng(next[1], next[0])
        p1 = CanvasShipUtils.GPSEncryptByMapToLatLng(p1, this._map)
        next1 = CanvasShipUtils.GPSEncryptByMapToLatLng(next1, this._map)
        center = [(p1.lat + next1.lat) / 2, (p1.lng + next1.lng) / 2]
      } else {
        center = null
      }
      if (center) {
        if (cname == '白令海峡') center[1] = center[1] + 360
        //绘制marker
        const marker = L.circleMarker(center as any, {
          radius: 5,
          color: '#fff',
          fillColor: 'red',
          weight: 1,
          opacity: 1,
          fillOpacity: 1,
        })
        this.lyGroup && this.lyGroup.addLayer(marker)
        this.layerHash[cname] = marker
        const layer = this._showName(marker, cname)
        const isIntersects = (layer: L.Polygon<any>) => {
          let res = false
          const layers = Object.values(this.layerHashName) as any
          for (const layer_ of layers) {
            if (layer_.getBounds().intersects(layer.getBounds())) {
              res = true
              break
            }
          }
          return res
        }
        if (!isIntersects(layer as any)) {
          this.layerHashName[cname] = layer
          this._map.addLayer(this.layerHashName[cname])
        }
      }
    })
  }
  _showName(p: L.Layer, name = '') {
    const color = this._map.mapType != 'MT_SATELLITE' ? '#fff' : '#333'
    return CommUtils.getFeatureLabel(p, name, {
      offset: [8, -10],
      attributes: {
        fill: color,
        xShift: 8,
      },
      pathOptions: {
        fillColor: 'rgba(1,29,60,.8)',
      },
      map: this._map,
    })
  }
  _hide() {
    try {
      if (this.lyGroup) {
        this.lyGroup.clearLayers()
        this.lyGroup = null
      }

      for (const item in this.layerHashName) {
        if (this._map.hasLayer(this.layerHashName[item])) {
          this._map.removeLayer(this.layerHashName[item])
          delete this.layerHashName[item]
        }
      }

      for (const item in this.layerHash) {
        this._map.removeLayer(this.layerHash[item])
        delete this.layerHash[item]
      }
    } catch (e) {
      console.log(e)
    }
  }
}

const elaneStraitSymbol = (
  map: MyMap,
  options?: Partial<AreaViewBaseOptions>
) => new ElaneStraitSymbol(map, options)

export { ElaneStraitSymbol, elaneStraitSymbol }
